module.exports = __webpack_public_path__ + "img/SD.00c0c6f7.svg";